import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const SearchIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 29 29">
		<path
			fill="currentColor"
			d="M12.5528 0.0292969C10.0688 0.0305485 7.64097 0.768381 5.5763 2.14948C3.51164 3.53058 1.90285 5.49292 0.953467 7.78834C0.00408439 10.0838 -0.243262 12.6092 0.242647 15.0452C0.728556 17.4812 1.92595 19.7184 3.68336 21.4739C5.44077 23.2294 7.6792 24.4243 10.1157 24.9076C12.5523 25.3908 15.0774 25.1407 17.3718 24.1888C19.6662 23.2369 21.6268 21.626 23.0056 19.5598C24.3845 17.4937 25.1197 15.065 25.1182 12.581C25.1132 9.25127 23.7872 6.05953 21.4315 3.70632C19.0757 1.35311 15.8826 0.0306894 12.5528 0.0292969ZM12.5528 22.8386C10.5271 22.839 8.54668 22.2387 6.86216 21.1135C5.17765 19.9884 3.86464 18.389 3.08914 16.5176C2.31365 14.6463 2.11054 12.5869 2.50548 10.6001C2.90042 8.61325 3.87572 6.78814 5.30796 5.3556C6.74021 3.92306 8.56503 2.94743 10.5518 2.55208C12.5385 2.15673 14.5979 2.35942 16.4695 3.13453C18.341 3.90964 19.9407 5.22235 21.0662 6.90663C22.1917 8.59092 22.7923 10.5711 22.7923 12.5968C22.7893 15.3118 21.7096 17.9147 19.79 19.8347C17.8704 21.7547 15.2678 22.8349 12.5528 22.8386Z"
		/>

		<path
			fill="currentColor"
			d="M28.1745 26.5773L21.5386 19.9235C21.3144 19.731 21.0255 19.6306 20.7303 19.6426C20.435 19.6545 20.1553 19.778 19.9474 19.988C19.7395 20.198 19.6189 20.479 19.6099 20.7744C19.601 21.0698 19.7043 21.3576 19.8991 21.5798L26.5414 28.2337C26.7743 28.4309 27.0751 28.5293 27.3795 28.5076C27.6839 28.4859 27.9677 28.346 28.1702 28.1177C28.3607 27.9066 28.4665 27.6326 28.4673 27.3483C28.4681 27.064 28.3637 26.7895 28.1745 26.5773Z"
		/>
	</SvgIcon>
)

export default SearchIconAtom
